$(document).ready(() => {
  totalPercent();

  $("div#incomePercent :input").keyup(function () {
    totalPercent();
  });

  function totalPercent() {
    let total = 0;

    $("div#incomePercent :input").each(function () {
      total += Number($(this).val());
    });

    $("#percentSumIncome").val(total);
  }
});
